<div class="app-loader">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
</div>